import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions } from './index';
import { PaginationProps } from '../types';

export type CountryListData = AnyObject

export type CountryListResponse = CountryListData
export type CountryListColumns = 'id' | 'name' | 'createdAt' | 'updatedAt'

export type CountryListGetParams = PaginationProps<CountryListColumns> & {
  search?: string;
  state?: number;
  city?: number;
}

const countryListGetDefaultParams: CountryListGetParams = {
  page: 1,
  pageSize: 10,
  orderByColumn: 'name',
};

export const countryList = (payload: CountryListGetParams): Action<CountryListGetParams> => ({
  type: actions.countryListTrigger.toString(),
  payload,
});

export const countryListClear = (): Action => ({
  type: actions.countryListClear.toString(),
});

export function* countryListRequestSaga({ payload }: Action<CountryListGetParams>) {
  yield put({
    type: actions.countryListStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.countryListError.toString(),
      payload: {
        message: 'CountryList: Parameters not passed.',
      },
    });

    return;
  }

  const params = new URLSearchParams(Object.entries({
    ...countryListGetDefaultParams,
    ...payload,
  })
    .map(([key, value]) => [key, value ? value.toString() : ''])
    .filter((entry) => !!entry[1]));

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/countries?${params.toString()}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<CountryListData, CountryListResponse>(
    response,
    actions.countryListSuccess.toString(),
    actions.countryListError.toString(),
    false,
    (countryListData) => countryListData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.countryListTrigger.toString(),
    defaultProcessingSaga(
      countryListRequestSaga,
      {
        error: actions.countryListError.toString(),
        locationCancel: actions.countryListClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.countryListSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.countryListError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.countryListErrorReset.toString(),
    });
  });
}
